export default "__VITE_ASSET__DU2He1la__"